import Paper from './Paper.view';

export default Paper;
